import Backbone from 'backbone';

/* note: this state exists on redux store and should only be used within backbone */
export default Backbone.Model.extend({
    url: '/web-gateway/device-info/primary-training-device',

    backend: 'gcapi',

    /* returns the primary training device's deviceId */
    getPrimaryTrainingDevice: function() {
        return this.has('PrimaryTrainingDevice') ? this.get('PrimaryTrainingDevice').deviceId : null;
    },

    /* returns the primary wearable device's deviceId */
    getPrimaryWearableDevice: function() {
        const devices = this.get('WearableDevices')?.deviceWeights;
        if (devices?.length > 0) {
            const primaryWearableDevice = devices.find((device) => device?.primaryWearableDevice);
            return primaryWearableDevice?.deviceId || null;
        }
        return null;
    },

    /* return all registered devices */
    getRegisteredDevices: function() {
        return this.get('RegisteredDevices');
    },

    /* return all pwd devices */
    getWearableDevices: function() {
        return this.get('WearableDevices')?.deviceWeights;
    },

    /* return all ptd devices */
    getPrimaryTrainingDevices: function() {
        return this.get('PrimaryTrainingDevices')?.deviceWeights;
    },

    /* determines if the devicePriority settings page should be shown */
    getShowDevicePriority: function() {
        return this.getPrimaryTrainingDevices()?.length > 1 || this.getWearableDevices()?.length > 1;
    },

    getPrimaryTrainingDeviceInfo: function() {
        let primaryId = this.getPrimaryTrainingDevice();
        return (
            this.get('PrimaryTrainingDevices') &&
            this.get('PrimaryTrainingDevices').deviceWeights.find((device) => device.deviceId === primaryId)
        );
    },

    getFullDeviceInfo: function(deviceId) {
        if (!deviceId) {
            return null;
        }

        let registeredDevices = this.get('RegisteredDevices');
        const fullDeviceInfo = registeredDevices.length
            ? registeredDevices.find((device) => device.deviceId === deviceId)
            : null;

        return fullDeviceInfo ? fullDeviceInfo : null;
    },

    getPrimaryWearableDeviceInfo: function() {
        let registeredDevices = this.get('RegisteredDevices');
        const primaryWearableDevice = registeredDevices.length
            ? registeredDevices.find((device) => device.primaryActivityTrackerIndicator)
            : null;

        return primaryWearableDevice ? primaryWearableDevice : null;
    }
});
